module.exports={
  "_from": "dotenv@^16.0.2",
  "_id": "dotenv@16.5.0",
  "_inBundle": false,
  "_integrity": "sha512-m/C+AwOAr9/W1UOIZUo232ejMNnJAJtYQjUbHoNTBNTJSvqzzDh7vnrei3o3r3m9blf6ZoDkvcw0VmozNRFJxg==",
  "_location": "/dotenv",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "dotenv@^16.0.2",
    "name": "dotenv",
    "escapedName": "dotenv",
    "rawSpec": "^16.0.2",
    "saveSpec": null,
    "fetchSpec": "^16.0.2"
  },
  "_requiredBy": [
    "/"
  ],
  "_resolved": "https://registry.npmjs.org/dotenv/-/dotenv-16.5.0.tgz",
  "_shasum": "092b49f25f808f020050051d1ff258e404c78692",
  "_spec": "dotenv@^16.0.2",
  "_where": "/opt/build/repo",
  "browser": {
    "fs": false
  },
  "bugs": {
    "url": "https://github.com/motdotla/dotenv/issues"
  },
  "bundleDependencies": false,
  "deprecated": false,
  "description": "Loads environment variables from .env file",
  "devDependencies": {
    "@types/node": "^18.11.3",
    "decache": "^4.6.2",
    "sinon": "^14.0.1",
    "standard": "^17.0.0",
    "standard-version": "^9.5.0",
    "tap": "^19.2.0",
    "typescript": "^4.8.4"
  },
  "engines": {
    "node": ">=12"
  },
  "exports": {
    ".": {
      "types": "./lib/main.d.ts",
      "require": "./lib/main.js",
      "default": "./lib/main.js"
    },
    "./config": "./config.js",
    "./config.js": "./config.js",
    "./lib/env-options": "./lib/env-options.js",
    "./lib/env-options.js": "./lib/env-options.js",
    "./lib/cli-options": "./lib/cli-options.js",
    "./lib/cli-options.js": "./lib/cli-options.js",
    "./package.json": "./package.json"
  },
  "funding": "https://dotenvx.com",
  "homepage": "https://github.com/motdotla/dotenv#readme",
  "keywords": [
    "dotenv",
    "env",
    ".env",
    "environment",
    "variables",
    "config",
    "settings"
  ],
  "license": "BSD-2-Clause",
  "main": "lib/main.js",
  "name": "dotenv",
  "repository": {
    "type": "git",
    "url": "git://github.com/motdotla/dotenv.git"
  },
  "scripts": {
    "dts-check": "tsc --project tests/types/tsconfig.json",
    "lint": "standard",
    "prerelease": "npm test",
    "pretest": "npm run lint && npm run dts-check",
    "release": "standard-version",
    "test": "tap run --allow-empty-coverage --disable-coverage --timeout=60000",
    "test:coverage": "tap run --show-full-coverage --timeout=60000 --coverage-report=lcov"
  },
  "types": "lib/main.d.ts",
  "version": "16.5.0"
}
